export const DEFAULT_PAYOUT_FORM = Object.freeze({
  address: undefined,
  amount: "0",
  currency: undefined,
})

export const DEFAULT_MANUAL_PAYOUTS_FORM = {
  fee_payer: "merchant",
  payouts: [{ ...DEFAULT_PAYOUT_FORM }],
}
